import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installGlobalErrorHandlers } from "@/lib/errorReporter";

// Feb 2026 — Wire the self-hosted crash reporter. Sits BEFORE the
// React tree renders so a TDZ/init-time crash still gets captured
// even if the ErrorBoundary itself never mounts. See
// routes/frontend_errors.py for the receiving endpoint.
installGlobalErrorHandlers();

// Suppress the benign "ResizeObserver loop completed with undelivered
// notifications" error that CRA's webpack-dev-server overlays in red on
// any page using shadcn dialogs/tabs. It's a no-op in production but
// blocks pointer events in dev. See: https://github.com/WICG/resize-observer/issues/38
const RESIZE_OBSERVER_ERR = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
  if (e?.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (e?.reason?.message && RESIZE_OBSERVER_ERR.test(e.reason.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
